import { GET_PAYMENT_REQUEST } from '../types/payment'

export function getPayment(payload) {
  return {
    type: GET_PAYMENT_REQUEST,
    payload,
  }
}
